import { Resource as e, API as a } from "@coveo/platform-client";
const r = class r extends e {
  async list(t) {
    return this.api.get(this.buildPath(`${r.baseUrl}`, t));
  }
};
r.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/v2/configurations/listings/rules`;
let s = r;
export {
  s as ListingRules
};
//# sourceMappingURL=ListingRules.js.map
